import BaseBtn from "src/component/ActionBtn/BaseBtn"
import ReportsPagesContent from "src/component/ReportsPagesContent"
import { GetRecurringRequests } from "src/requests/RecurringRequests"
import { RecurringRequest } from "src/types/Requests/MobRecurringRequests"
import { CellOriginal, ColumnType } from "src/types/Table/table"
import { checkIfSelectedPharmacy, dateFormatter, errorToaster } from "src/utils"
import RecurringRequestMedicines from "./Popups/RecurringRequestMedicines/RecurringRequestMedicines"
import { useRef, useState } from "react"
import { GetServiceTypesLookup } from "src/requests/Shared"
import SearchWrapper from "src/component/searchSection"
import { useLocation } from "react-router-dom"

const RecurringRequests = () => {
    const recurringRequestMedicinesRef = useRef<any>(null)

    const [selectedRow, setSelectedRow] = useState<RecurringRequest | null>(null)

    const { state } = useLocation()

    const columns: ColumnType<RecurringRequest & { keyword: string }>[] = [
        {
            Header: 'keyWord',
            accessor: 'keyword',
            label: 'nameOrNationalIdOrDecisionNumber',
            canSearch: true,
            visible: false
        },
        {
            Header: 'decisionCode',
            accessor: 'decisionId',
        },
        {
            Header: 'decisionNumber',
            accessor: 'decisionNumber'
        },
        {
            Header: 'patientName',
            accessor: 'patientName'
        },
        {
            Header: 'patientNationalId',
            accessor: 'patientNationalId'
        },
        {
            Header: 'hospital',
            accessor: 'hospital'
        },
        {
            Header: 'monthlyAmount',
            accessor: 'monthlyAmount'
        },
        {
            Header: 'remainingAmount',
            accessor: 'remainingAmount'
        },
        {
            Header: 'diagnosis',
            accessor: 'diagnosis'
        },
        {
            Header: 'serviceType',
            accessor: 'serviceType',
            probName: 'serviceTypeId',
            canSearch: true,
            type: "DropDown",
            sourceApi: GetServiceTypesLookup
        },
        {
            Header: 'isRegisteredForDelivery',
            accessor: 'isRegisteredForDelivery'
        },
        {
            Header: 'deliveryDateThisMonth',
            Cell: ({ row: { original } }: CellOriginal<RecurringRequest>) => {
                return (
                    <>
                        {dateFormatter(original.deliveryDateThisMonth, "ar", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })}
                    </>
                )
            }
        },
        {
            Header: 'decisionType',
            accessor: 'decisionType'
        },
        {
            Header: 'decisionStartDate',
            Cell: ({ row: { original } }: CellOriginal<RecurringRequest>) => {
                return (
                    <>{dateFormatter(original.decisionStartDate, "ar", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                    })}
                    </>
                )

            }
        },
        {
            Header: 'decisionEndDate',
            Cell: ({ row: { original } }: CellOriginal<RecurringRequest>) => {
                return (
                    <>
                        {dateFormatter(original.decisionEndDate, "ar", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })}
                    </>
                )
            }
        },
        {
            Header: 'actions',
            Cell: ({ row: { original } }: CellOriginal<RecurringRequest>) => {
                return (
                    <>
                        <BaseBtn
                            icon={"material-symbols:edit-sharp"}
                            className='update'
                            ApplyAction={() => ShowActionPopup(original)}
                        />
                    </>)
            },
        }
    ]


    const ShowActionPopup = (row: RecurringRequest) => {
        if (!checkIfSelectedPharmacy(state)) return errorToaster("please-select-hosptial")

        setSelectedRow(row)
        recurringRequestMedicinesRef.current?.click()

    }

    return (
        <>
            <RecurringRequestMedicines
                modalID={recurringRequestMedicinesRef}
                items={selectedRow}
                setSelectedItems={setSelectedRow}
            />

            <ReportsPagesContent
                tableAPI={
                    (searchData: any, tableFiller: any) =>
                        GetRecurringRequests(searchData, tableFiller, Number(sessionStorage.getItem("hopsitalId")))
                }
                columns={columns}
            >
                <SearchWrapper />
            </ReportsPagesContent>
        </>
    )
}

export default RecurringRequests